(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-contact-chat]').forEach((button) => {
    button.addEventListener('click', () => {
      if (typeof window.Intercom === 'function') {
        window.Intercom('showNewMessage');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-quickbuy-2"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('quick-buy-shift')) {
    customElements.define('quick-buy-shift', class QuickBuyShift extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('[data-shift-viewport]');
        this.thumb = this.querySelector('[data-shift-thumb]');
        if (!this.viewport || !this.thumb) return;
        this.updateScrollbar = this.updateScrollbar.bind(this);
        this.viewport.addEventListener('scroll', this.updateScrollbar, { passive: true });
        this.resizeObserver = new ResizeObserver(this.updateScrollbar);
        this.resizeObserver.observe(this.viewport);
        this.updateScrollbar();
      }

      disconnectedCallback() {
        if (!this.viewport) return;
        this.viewport.removeEventListener('scroll', this.updateScrollbar);
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }

      updateScrollbar() {
        const scrollDistance = this.viewport.scrollWidth - this.viewport.clientWidth;
        const track = this.thumb.parentElement;
        const thumbTravel = track.clientWidth - this.thumb.clientWidth;
        const progress = scrollDistance > 0 ? this.viewport.scrollLeft / scrollDistance : 0;
        this.thumb.style.transform = `translateX(${progress * thumbTravel}px)`;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-summer-starts-here-hero"] && !Shopify.designMode) return;
  try {
    
  const setupSummerStartsHereHeroes = () => {
    document.querySelectorAll('.summer-starts-here-hero').forEach((hero) => {
      if (hero.dataset.summerHeroReady === 'true') return;

      const zone = hero.querySelector('.summer-starts-here-hero__interaction-zone');
      const touchScrollQuery = window.matchMedia('(max-width: 1024px), (hover: none), (pointer: coarse)');
      const activateOnTouchScroll = () => {
        if (!touchScrollQuery.matches) return;
        hero.classList.toggle('is-slide-active', window.scrollY > 4);
      };
      const handleResize = () => {
        if (touchScrollQuery.matches) {
          activateOnTouchScroll();
        } else {
          hero.classList.remove('is-slide-active');
        }
      };

      if (zone) {
        zone.addEventListener('mouseenter', () => hero.classList.add('is-slide-active'));
        zone.addEventListener('mouseleave', () => hero.classList.remove('is-slide-active'));
        zone.addEventListener('focus', () => hero.classList.add('is-slide-active'));
        zone.addEventListener('blur', () => hero.classList.remove('is-slide-active'));
      }

      window.addEventListener('scroll', activateOnTouchScroll, { passive: true });
      window.addEventListener('touchmove', activateOnTouchScroll, { passive: true });
      window.addEventListener('resize', handleResize, { passive: true });
      hero.dataset.summerHeroReady = 'true';
      handleResize();
    });
  };

  setupSummerStartsHereHeroes();
  document.addEventListener('shopify:section:load', setupSummerStartsHereHeroes);

  } catch(e) { console.error(e); }
})();
})();
